import { request } from '@/common/utils/request'

export function getVisitList (params) {
  return request.get({
    url: 'crm.visit.visit.list',
    params
  }).then(res => res.data)
}
